import { render, staticRenderFns } from "./FeaturedRequests.vue?vue&type=template&id=47188fd6&"
import script from "./FeaturedRequests.vue?vue&type=script&lang=js&"
export * from "./FeaturedRequests.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedRequests.vue?vue&type=style&index=0&id=47188fd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports